import * as React from "react";
import { CategorizedPageHelpRegistration, RenderRegistrationCardProps } from "../../../Registry/pageHelpRegistry";
import pageIds from "pageIds";
import { CommonConfigurationTestPermissionOverview, CommonConfigurationTestPermissionTopics } from "../../CommonComponents/CommonConfigurationTestPermissionViews";

export const ConfigurationTestPermissionRegistration: CategorizedPageHelpRegistration = {
    page: pageIds.configuration.testPermission,
    renderOverview: (renderProps: RenderRegistrationCardProps) => {
        return <CommonConfigurationTestPermissionOverview />;
    },
    renderTopics: (renderProps: RenderRegistrationCardProps) => {
        return <CommonConfigurationTestPermissionTopics />;
    },
};
